<div style="display: flex; justify-content: space-between; width: 100vw;">
  <!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

  <div class="header-container">
    <div class="logo-container" style="display: flex; justify-content: center;">
      <a (click)="toggleSidebar()" href="https://supdc.studentscenter.in/pages/student-dashboard/"
        class="sidebar-toggle">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </a>
      <div class ="logo" (click)="navigateHome()">
        <a href=""> <img src="https://devsuverify.studentscenter.in/api/upload/profile_pic/sulogo.png" style="width: 60px" alt="logo">Provisional / Passing Certificate</a>
      </div>
      <!-- <a class="logo" href="https://devsuverify.studentscenter.in/api/upload/profile_pic/sulogo.png" (click)="navigateHome()">Provisional / Passing Certificate</a> -->
    </div>



    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
        <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
      </nb-select> -->
  </div>
  <!-- <div class="form-group" class="abc">
    <select (change)="onChange($event.target.value)" name="languagectrl" id="languagectrl" class="form-control"
      placeholder="Please Select Language" formControlName="languagectrl">
      <option _ngcontent-jco-c75="" value="" disabled="" selected=""> Please Select Language
      </option>
      <option _ngcontent-jco-c75="" value="English" class="ng-star-inserted">English</option>
      <option _ngcontent-jco-c75="" value="Marathi" class="ng-star-inserted"> Marathi</option>
    </select>
  </div> -->
  
  <!-- <p (click)="demo()">FAQ &nbsp;&nbsp;&nbsp; <i class="fa-solid fa-clipboard-question"></i></p> -->
  <!-- <p (click)="open()">Contact us &nbsp;&nbsp;&nbsp; <i class="fa-solid fa-clipboard-question"></i></p> -->
  <div class="header-container" style="display: flex; align-items: center;">
    <!-- <div style="margin-left: -60px; margin-right: 20px;" *ngIf="getuser === 'student'">
      <button nbButton size="small" (click)="navigate()">
        <i class="fa fa-shopping-cart fa-2x" aria-hidden="true"></i>
      </button>
    </div> -->
    <div>
      <nb-actions size="small" style="margin-bottom: -20px;">
        <nb-action class="user-action">
          <nb-user [nbContextMenu]="userMenu" name=""
            picture="https://i.pinimg.com/474x/2e/4f/d3/2e4fd3fd8f2aff9c26b15c1f1c23b11e.jpg">
          </nb-user>
        </nb-action>
      </nb-actions>
    </div>
  </div>
  
</div>